import React from 'react';
import { PropsWithChildren } from 'react';
import { wrap } from './style';

function PageTitle({ children }: PropsWithChildren) {
  return <h3 css={wrap}>{children}</h3>;
}

export default PageTitle;
